<template>
  <div>
    <h1 class="mt-12 mb-12 ml-12 font-weight-light">{{ pageHeading }}</h1>
    <v-card v-for="r in pageData" :key="r.id" class="mx-auto my-12">
      <v-container>
        <v-row>
          <v-col class="md4 lg4 xl4 sm12">
            <v-img
              height="250"
              contain
              :src="r.fields.IMAGE"
              :alt="r.fields.TITLE"
            ></v-img>
          </v-col>
          <v-col>
            <v-card-title class="font-weight-black">{{
              r.fields.TITLE
            }}</v-card-title>

            <v-card-text>
              <v-row align="center" class="mx-0">
                <v-rating
                  aria-label="Rate out of 5 stars"
                  :value="parseFloat(r.fields.RATING)"
                  half-increments
                  readonly
                >
                  <template v-slot:item="props">
                    <v-icon aria-label="star" color="amber" size="20">{{
                      props.isFilled ? "mdi-star" : "mdi-star-outline"
                    }}</v-icon>
                  </template>
                </v-rating>

                <div class="black--text ml-4">
                  {{ r.fields.RATING }} ({{ r.fields.REVIEWS }})
                </div>
              </v-row>

              <div class="my-4 subtitle-1 black--text">
                {{ r.fields.PRICE }}

                <v-chip class="ml-4">{{ r.fields.TYPE }}</v-chip>
              </div>

              <div>
                {{ r.fields.DESCRIPTION }}
              </div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-actions class="mb-12">
              <v-row>
                <v-col>
                  <router-link
                    :to="{ name: 'Details', query: { record: r.id } }"
                    @click="this.$ga.event({
  eventCategory: 'seeAll',
  eventAction: 'route-to-details-page',
  eventLabel: 'see-more-details-button'
})"
                  >
                    <v-btn
                      class="pl-4 pr-6 mr-6"
                      x-large
                      color="amber darken-1"
                      aria-label="See more details button"
                    >
                      <v-icon class="pr-3">
                        mdi-note-text
                      </v-icon>
                      See More Details
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col>
                  <v-btn
                    class="pl-12 pr-12"
                    @click="enroll(r.fields.URL)"
                    x-large
                    color="primary"
                    aria-label="Enroll button"
                  >
                    <v-icon class="pr-3"
                      >mdi-checkbox-marked-circle-outline</v-icon
                    >
                    Enroll
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageData: null,
      pageHeading: "",
    };
  },
  created() {
    this.pageData = this.$route.params.pageData;
    this.pageHeading = this.$route.params.pageHeading;
  },
  methods: {
    enroll(url) {
      window.open(`${url}`,'_blank','noopener');
    },
  },
};
</script>
